import { Point2D } from "./Point2D.js";
import { MathUtil } from "../math/MathUtil.js";
import { isSizeType } from "./SizeType.js";
const isValueLinkControl = (data) => {
  return typeof data === "object" && "value" in data && "noLink" in data;
};
class Rect {
  constructor(xOrPoint, yOrPointOrWidth, widthOrHeight = 0, heightOrUndefined = 0) {
    if (isSizeType(xOrPoint)) {
      this._start = new Point2D(0, 0);
      this._width = xOrPoint.width;
      this._height = xOrPoint.height;
    } else if (typeof xOrPoint === "object" && typeof yOrPointOrWidth === "object") {
      this._start = xOrPoint instanceof Point2D ? xOrPoint : new Point2D(xOrPoint.x, xOrPoint.y);
      this.end = yOrPointOrWidth instanceof Point2D ? yOrPointOrWidth : new Point2D(yOrPointOrWidth.x, yOrPointOrWidth.y);
    } else if (typeof xOrPoint === "object" && typeof yOrPointOrWidth === "number") {
      this._start = xOrPoint instanceof Point2D ? xOrPoint : new Point2D(xOrPoint.x, xOrPoint.y);
      this._width = yOrPointOrWidth;
      this._height = widthOrHeight;
    } else if (typeof xOrPoint === "number" && typeof yOrPointOrWidth === "number") {
      this._start = new Point2D(xOrPoint, yOrPointOrWidth);
      this._width = widthOrHeight;
      this._height = heightOrUndefined;
    }
  }
  valueLinkControl(value) {
    let v;
    let noLink = false;
    if (isValueLinkControl(value)) {
      v = value.value;
      noLink = value.noLink;
    } else {
      v = value;
    }
    return { value: v, noLink };
  }
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
  get start() {
    return this._start.copy();
  }
  ////////////////////
  set width(width) {
    this.setWidth(width);
  }
  setWidth(width) {
    let { value, noLink } = this.valueLinkControl(width);
    const percentDiff = MathUtil.getPercentByTotal(this._width, value);
    this._width = value;
    this.applyWidthPercentLinks({ value: percentDiff, noLink });
  }
  set height(height) {
    this.setHeight(height);
  }
  setHeight(height) {
    let { value, noLink } = this.valueLinkControl(height);
    const percentDiff = MathUtil.getPercentByTotal(this._height, value);
    this._height = value;
    this.applyHeightPercentLinks({ value: percentDiff, noLink });
  }
  set start(inputValue) {
    let { value, noLink } = this.valueLinkControl(inputValue);
    const percentDiff = new Point2D({ x: MathUtil.getPercentByTotal(this._start.x, value.x), y: MathUtil.getPercentByTotal(this._start.y, value.y) });
    this._start = value;
    this.applyStartPercentLinks({ value: percentDiff, noLink });
  }
  // 언제쓰는거지 ㅡㅡ?
  setWidthFromEnd(inputValue) {
    let { value, noLink } = this.valueLinkControl(inputValue);
    const percentDiff = MathUtil.getPercentByTotal(this.start.x, value);
    this._start.x = this.end.x - value;
    this.applyStartXPercentLinks({ value: percentDiff, noLink });
  }
  set widthFromEnd(inputValue) {
    this.setWidthFromEnd(inputValue);
  }
  // 언제쓰는거지 ㅡㅡ?
  setHeightFromEnd(inputValue) {
    let { value, noLink } = this.valueLinkControl(inputValue);
    const diff = this.end.y - value;
    const percentDiff = MathUtil.getPercentByTotal(this.start.y, diff);
    this._start.y = diff;
    this.applyStartYPercentLinks({ value: percentDiff, noLink });
  }
  set heightFromEnd(inputValue) {
    this.setHeightFromEnd(inputValue);
  }
  setWidthFromCenter(inputValue) {
    let { value, noLink } = this.valueLinkControl(inputValue);
    const diff = this.center.x - value / 2;
    const percentDiff = MathUtil.getPercentByTotal(this.start.x, diff);
    this._start.x = diff;
    this.applyStartXPercentLinks(percentDiff);
  }
  set widthFromCenter(inputValue) {
    this.setWidthFromCenter(inputValue);
  }
  setHeightFromCenter(inputValue) {
    let { value, noLink } = this.valueLinkControl(inputValue);
    const diff = this.center.y - value / 2;
    const percentDiff = MathUtil.getPercentByTotal(this.start.y, diff);
    this._start.y = diff;
    this.applyStartYPercentLinks(percentDiff);
  }
  set heightFromCenter(inputValue) {
    let { value, noLink } = this.valueLinkControl(inputValue);
    const diff = this.center.y - value / 2;
    const percentDiff = MathUtil.getPercentByTotal(this.start.y, diff);
    this._start.y = diff;
    this.applyStartYPercentLinks(percentDiff);
  }
  set x(inputValue) {
    this.setX(inputValue);
  }
  setX(inputValue) {
    let { value, noLink } = this.valueLinkControl(inputValue);
    const diff = value - this._start.x;
    const percentDiff = MathUtil.getPercentByTotal(this.width, diff);
    this._start.x = value;
    this.applyStartXPercentLinks({ value: percentDiff, noLink });
  }
  set y(inputValue) {
    this.setY(inputValue);
  }
  setY(inputValue) {
    let { value, noLink } = this.valueLinkControl(inputValue);
    const diff = value - this._start.y;
    const percentDiff = MathUtil.getPercentByTotal(this.height, diff);
    this._start.y = value;
    this.applyStartYPercentLinks({ value: percentDiff, noLink });
  }
  ////////////////////////////
  applyWidthPercentLinks(widthPercent) {
    let { value, noLink } = this.valueLinkControl(widthPercent);
    if (this.linkRects && (typeof noLink === "boolean" ? !noLink : true)) {
      Array.from(this.linkRects.values()).filter((it) => {
        return typeof noLink === "boolean" ? true : it !== noLink;
      }).forEach((it) => {
        it.setWidthByWidthPercent({ value, noLink: this });
      });
    }
  }
  applyHeightPercentLinks(heightPercent) {
    let { value, noLink } = this.valueLinkControl(heightPercent);
    if (this.linkRects && (typeof noLink === "boolean" ? !noLink : true)) {
      Array.from(this.linkRects.values()).filter((it) => {
        return typeof noLink === "boolean" ? true : it !== noLink;
      }).forEach((it) => {
        it.setHeightByHeightPercent({ value, noLink: this });
      });
    }
  }
  applyStartPercentLinks(startPercent) {
    let { value, noLink } = this.valueLinkControl(startPercent);
    this.applyStartXPercentLinks({ value: value.x, noLink });
    this.applyStartYPercentLinks({ value: value.y, noLink });
  }
  applyStartXPercentLinks(xPercent) {
    let { value, noLink } = this.valueLinkControl(xPercent);
    if (this.linkRects && (typeof noLink === "boolean" ? !noLink : true)) {
      Array.from(this.linkRects.values()).filter((it) => {
        return typeof noLink === "boolean" ? true : it !== noLink;
      }).forEach((it) => {
        it.addXByWidthPercent({ value, noLink: this });
      });
    }
  }
  applyStartYPercentLinks(yPercent) {
    let { value, noLink } = this.valueLinkControl(yPercent);
    if (this.linkRects && (typeof noLink === "boolean" ? !noLink : true)) {
      Array.from(this.linkRects.values()).filter((it) => {
        return typeof noLink === "boolean" ? true : it !== noLink;
      }).forEach((it) => {
        it.addYByHeightPercent({ value, noLink: this });
      });
    }
  }
  hasLink(rect) {
    return this.linkRects?.has(rect);
  }
  isLinked() {
    return !!this.linkRects?.size;
  }
  addLink(...rect) {
    this.linkRects ?? (this.linkRects = /* @__PURE__ */ new Set());
    rect.filter((it) => !this.linkRects?.has(it)).forEach((it) => {
      this.linkRects?.add(it);
      it.addLink(this);
    });
  }
  setLinks(rects) {
    this.unLinkAll();
    this.addLink(...rects);
  }
  unLinkAll() {
    if (this.linkRects) {
      Array.from(this.linkRects.values()).forEach((it) => {
        this.unLink(it);
      });
      this.linkRects.clear();
    }
  }
  unLink(rect) {
    let { value, noLink } = this.valueLinkControl(rect);
    if (this.linkRects) {
      this.linkRects.delete(value);
    }
    if (!noLink)
      value.unLink({ value: this, noLink: this });
  }
  addWidthPercent(wPercent) {
    let { value, noLink } = this.valueLinkControl(wPercent);
    this.setWidth({ value: this.width + MathUtil.getValueByTotalInPercent(this.width, value), noLink });
  }
  addHeightPercent(hPercent) {
    let { value, noLink } = this.valueLinkControl(hPercent);
    this.setHeight({ value: this.height + MathUtil.getValueByTotalInPercent(this.height, value), noLink });
  }
  addWidthRatio(wRatio) {
    this.width = this.width + MathUtil.getValueByTotalInRatio(this.width, wRatio);
  }
  addHeightRatio(hRatio) {
    this.height = this.height + MathUtil.getValueByTotalInRatio(this.height, hRatio);
  }
  addXPercent(wPercent) {
    let { value, noLink } = this.valueLinkControl(wPercent);
    this.setX({ value: this.x + MathUtil.getValueByTotalInPercent(this.width, value), noLink });
  }
  addYPercent(hPercent) {
    let { value, noLink } = this.valueLinkControl(hPercent);
    this.setY({ value: this.y + MathUtil.getValueByTotalInPercent(this.height, value), noLink });
  }
  addXRatio(wRatio) {
    let { value, noLink } = this.valueLinkControl(wRatio);
    this.setX({ value: this.x + MathUtil.getValueByTotalInRatio(this.width, value), noLink });
  }
  addYRatio(hRatio) {
    let { value, noLink } = this.valueLinkControl(hRatio);
    this.setY({ value: this.y + MathUtil.getValueByTotalInRatio(this.height, value), noLink });
  }
  ////////////
  set endX(value) {
    const diff = value - this.x;
    this.width = diff;
  }
  set endXPercent(endXPercent) {
    this.endX = MathUtil.getValueByTotalInPercent(this.width, endXPercent);
  }
  set endYPercent(endYPercent) {
    this.endY = MathUtil.getValueByTotalInPercent(this.height, endYPercent);
  }
  set endY(value) {
    this.height = value - this.y;
  }
  set end(value) {
    this.width = value.x - this.x;
    this.height = value.y - this.y;
  }
  get x() {
    return this.start.x;
  }
  get y() {
    return this.start.y;
  }
  get endX() {
    return this.end.x;
  }
  get endY() {
    return this.end.y;
  }
  to(startPoint) {
    const r = this.copy();
    r.start = startPoint;
    return r;
  }
  toRotate(r, { rotatePoint = this.center, type = "degreeAngle" }) {
    const angle = MathUtil.radians(r, { type });
    const centerPoint = rotatePoint instanceof Point2D ? rotatePoint : new Point2D(rotatePoint.x, rotatePoint.y);
    const points = [
      this.leftTop,
      this.rightTop,
      this.rightBottom,
      this.leftBottom
    ];
    return points.map((p) => MathUtil.rotatePoint(p, centerPoint, angle));
  }
  get center() {
    return new Point2D(this.start.x + this.width / 2, this.start.y + this.height / 2);
  }
  get end() {
    return new Point2D(this.start.x + this.width, this.start.y + this.height);
  }
  get leftTop() {
    return this.start.copy();
  }
  get leftBottom() {
    return new Point2D(this.start.x, this.end.y);
  }
  get rightTop() {
    return new Point2D(this.end.x, this.start.y);
  }
  get rightBottom() {
    return this.end;
  }
  copy() {
    return new Rect(this.x, this.y, this.width, this.height);
  }
  /////////////////
  getWidthPercent(width) {
    return MathUtil.getPercentByTotal(this.width, width);
  }
  getWidthRatio(width) {
    return MathUtil.getRatioByTotal(this.width, width);
  }
  getWidthByPercent(percent) {
    return MathUtil.getValueByTotalInPercent(this.width, percent);
  }
  getWidthByRatio(percent) {
    return MathUtil.getValueByTotalInRatio(this.width, percent);
  }
  getHeightPercent(height) {
    return MathUtil.getPercentByTotal(this.height, height);
  }
  getHeightRatio(height) {
    return MathUtil.getRatioByTotal(this.height, height);
  }
  getHeightByPercent(percentY) {
    return MathUtil.getValueByTotalInPercent(this.height, percentY);
  }
  getHeightByRatio(ratio) {
    return MathUtil.getValueByTotalInRatio(this.height, ratio);
  }
  getXPercent(x) {
    return MathUtil.getPercentByTotal(this.width, x - this.x);
  }
  getXRatio(x) {
    return MathUtil.getRatioByTotal(this.width, x - this.x);
  }
  getXByPercent(xPercent) {
    return this.x + MathUtil.getValueByTotalInPercent(this.width, xPercent);
  }
  getXByRatio(ratio) {
    return this.x + MathUtil.getValueByTotalInRatio(this.width, ratio);
  }
  getYPercent(y) {
    return MathUtil.getPercentByTotal(this.height, y - this.y);
  }
  getYRatio(y) {
    return MathUtil.getRatioByTotal(this.height, y - this.y);
  }
  getYByPercent(yPercent) {
    return this.y + MathUtil.getValueByTotalInPercent(this.height, yPercent);
  }
  getYByRatio(ratio) {
    return this.y + MathUtil.getValueByTotalInRatio(this.height, ratio);
  }
  getPercent(point) {
    return new Point2D(
      this.getXPercent(point.x),
      this.getYPercent(point.y)
    );
  }
  /**
   * 주어진 width에 맞춰 비율에 따라 height를 스케일링하여 새로운 Rect를 반환합니다.
   * @param width 새로운 width 값
   * @returns 비율에 맞게 height가 조정된 Rect
   */
  toScaleByWidth(width) {
    const ratio = this.height / this.width;
    return new Rect(this.x, this.y, width, width * ratio);
  }
  /**
   * 주어진 height에 맞춰 비율에 따라 width를 스케일링하여 새로운 Rect를 반환합니다.
   * @param height 새로운 height 값
   * @returns 비율에 맞게 width가 조정된 Rect
   */
  toScaleByHeight(height) {
    const ratio = this.width / this.height;
    return new Rect(this.x, this.y, height * ratio, height);
  }
  toRatio(point) {
    return new Rect(
      this.getXRatio(point.x),
      this.getYRatio(point.y),
      this.getWidthRatio(point instanceof Rect ? point.width : point.w),
      this.getHeightRatio(point instanceof Rect ? point.height : point.h)
    );
  }
  getRatio(point) {
    return new Point2D(
      this.getXRatio(point.x),
      this.getYRatio(point.y)
    );
  }
  getByPercent(percent) {
    return new Point2D(
      this.getXByPercent(percent.x),
      this.getYByPercent(percent.y)
    );
  }
  getByRatio(ratio) {
    return new Point2D(
      this.getXByRatio(ratio.x),
      this.getYByRatio(ratio.y)
    );
  }
  getDiffX(x) {
    return x - this.x;
  }
  getDiffY(y) {
    return y - this.y;
  }
  getDiffLeft(x) {
    this.getDiffX(x);
  }
  getDiffTop(y) {
    this.getDiffY(y);
  }
  getDiffRight(x) {
    return x - this.end.x;
  }
  getDiffBottom(y) {
    return y - this.end.y;
  }
  getDiffWidth(width) {
    return width - this.width;
  }
  getDiffHeight(height) {
    return height - this.height;
  }
  toDiff(rect) {
    return new Rect(
      rect.x - this.x,
      rect.y - this.y,
      rect.width - this.width,
      rect.height - this.height
    );
  }
  setXByWidthPercent(wPercent) {
    let { value, noLink } = this.valueLinkControl(wPercent);
    this.setX({ value: MathUtil.getValueByTotalInPercent(this.width, value), noLink });
  }
  set xByWidthPercent(wPercent) {
    this.setXByWidthPercent(wPercent);
  }
  setXByWidthRatio(wRatio) {
    let { value, noLink } = this.valueLinkControl(wRatio);
    this.setX({ value: MathUtil.getValueByTotalInRatio(this.width, value), noLink });
  }
  set xByWidthRatio(wRatio) {
    this.setXByWidthRatio(wRatio);
  }
  setYByHeightPercent(hPercent) {
    let { value, noLink } = this.valueLinkControl(hPercent);
    this.setY({ value: MathUtil.getValueByTotalInPercent(this.height, value), noLink });
  }
  set yByHeightPercent(hPercent) {
    this.setYByHeightPercent(hPercent);
  }
  setYByHeightRatio(ratio) {
    let { value, noLink } = this.valueLinkControl(ratio);
    this.setY({ value: MathUtil.getValueByTotalInRatio(this.height, value), noLink });
  }
  set yByHeightRatio(ratio) {
    this.setYByHeightRatio(ratio);
  }
  addXByWidthPercent(wPercent) {
    let { value, noLink } = this.valueLinkControl(wPercent);
    this.setX({ value: this.x + MathUtil.getValueByTotalInPercent(this.width, value), noLink });
  }
  addXByWidthRatio(wRatio) {
    let { value, noLink } = this.valueLinkControl(wRatio);
    this.setX({ value: this.x + MathUtil.getValueByTotalInRatio(this.width, value), noLink });
  }
  addYByHeightPercent(hPercent) {
    let { value, noLink } = this.valueLinkControl(hPercent);
    this.setY({ value: this.y + MathUtil.getValueByTotalInPercent(this.height, value), noLink });
  }
  addYByHeightRatio(ratio) {
    let { value, noLink } = this.valueLinkControl(ratio);
    this.setY({ value: this.y + MathUtil.getValueByTotalInRatio(this.height, value), noLink });
  }
  setWidthByWidthPercent(wPercent) {
    let { value, noLink } = this.valueLinkControl(wPercent);
    this.setWidth({ value: MathUtil.getValueByTotalInPercent(this.width, value), noLink });
  }
  set widthByWidthPercent(wPercent) {
    this.setWidthByWidthPercent(wPercent);
  }
  setWidthByWidthRatio(wRatio) {
    let { value, noLink } = this.valueLinkControl(wRatio);
    this.setWidth({ value: MathUtil.getValueByTotalInRatio(this.width, value), noLink });
  }
  set widthByWidthRatio(wRatio) {
    this.setWidthByWidthRatio(wRatio);
  }
  setHeightByHeightPercent(hPercent) {
    let { value, noLink } = this.valueLinkControl(hPercent);
    this.setHeight({ value: MathUtil.getValueByTotalInPercent(this.height, value), noLink });
  }
  set heightByHeightPercent(hPercent) {
    this.setHeightByHeightPercent(hPercent);
  }
  setHeightByHeightRatio(hRatio) {
    let { value, noLink } = this.valueLinkControl(hRatio);
    this.setHeight({ value: MathUtil.getValueByTotalInRatio(this.height, value), noLink });
  }
  set heightByHeightRatio(hRatio) {
    this.setHeightByHeightRatio(hRatio);
  }
  copyByPercent(percentOrX, percentY) {
    return new Rect(
      this.x,
      this.y,
      MathUtil.getValueByTotalInPercent(this.width, percentOrX),
      MathUtil.getValueByTotalInPercent(this.height, percentY ?? percentOrX)
    );
  }
  copyByRatio(ratioOrX, ratioY) {
    return new Rect(
      this.x,
      this.y,
      MathUtil.getValueByTotalInRatio(this.width, ratioOrX),
      MathUtil.getValueByTotalInRatio(this.height, ratioY ?? ratioOrX)
    );
  }
  isIn(data) {
    if (data instanceof Rect) {
      return this.isIn(data.start) && this.isIn(data.end);
    } else {
      return data.x >= this.start.x && data.x <= this.end.x && data.y >= this.start.y && data.y <= this.end.y;
    }
  }
  isOut(data) {
    if (data instanceof Rect) {
      return !this.isOverlap(data);
    } else {
      return !this.isIn(data);
    }
  }
  isOverlap(data) {
    if (data instanceof Rect) {
      const noOverlap = this.endX < data.x || this.x > data.endX || this.endY < data.y || this.y > data.endY;
      return !noOverlap;
    } else {
      return this.isIn(data);
    }
  }
  toString() {
    return `x:${this.x}, y:${this.y}, width: ${this.width}, height: ${this.height}`;
  }
}
export {
  Rect
};
//# sourceMappingURL=Rect.js.map
